<template>
    <div class="m-auto" style="max-width:90%">
        <v-sheet
            :color="theme.backgroundColor"
            rounded="xl"
            class="m-auto"
            :height="sheetHeight"
            width="100%"
            max-width="600"
        >
            <EspAvatarUploader
                :url="avatarUrl"
                :request="request"
                :rename="rename"
                size="100%"
                tile
                :clickable="!hasUserInput"
                :allowedMimeType="allowedMimeType"
                :maxSize="maxSize"
                :cameraChoice="cameraChoice"
                @error-size="onErrorSize"
                @error-type="onErrorType"
                @success="success"
                @failed="failed"
                @loading="onLoading"
            >
                <template #none>
                    <EspError v-show="isMimeTypeImage(allowedMimeType)"
                              icon="mdi-camera-plus"
                              :text="$t('app_task_photo_select')"
                              class="pb-12"
                              :isMobile="isMobile"
                              :style="{'border': '1px solid ' + theme.textColor, 'width': '100%', 'border-radius': '12px'}"
                    />
                    <EspError v-show="isMimeTypeVideo(allowedMimeType)"
                              icon="mdi-video-plus"
                              :text="$t('app_task_video_select')"
                              class="pb-12"
                              :isMobile="isMobile"
                              :style="{'border': '1px solid ' + theme.textColor, 'width': '100%', 'border-radius': '12px'}"
                    />
                </template>
                <template #loading="{ }">
                    <div class="m-auto pt-12" >
                        <v-progress-circular
                            indeterminate
                            :size="100"
                            :width="4"
                            :color="theme.textColor"
                        />
                        <h2 class="pt-3" :style="{'color': theme.textColor}">
                            <span v-if="isImage(filename)" >{{$t('app_task_photo_loading')}}</span>
                            <span v-else-if="isVideo(filename)">{{$t('app_task_video_loading')}}</span>
                        </h2>
                    </div>
                </template>
            </EspAvatarUploader>
        </v-sheet>
        <div class="px-5 pt-1">
        </div>
    </div>
</template>

<script>
import CONFIG from "../../constants/config";
import {layoutMixin} from "../../utils/layout-mixin";
import {imageMixin} from "../../utils/image-mixin";
import {solutionMixin} from "../../utils/solution-mixin";
import {EventBusNotification} from "../EventBusNotification";
import EspError from "../animation/EspError";
import EspAvatarUploader from "../ui/EspAvatarUploader";
import Media from "../../api/media";

export default {
    mixins:[layoutMixin,solutionMixin,imageMixin],
    components: {
        EspAvatarUploader,
        EspError
    },
    props:{
        spot:{},
        eventId:{},
        userId:{},
        teamId:{},
        allowedMimeType:{
            type:String,
            default:'image.*'
        },
        maxSize: {
            type: Number,
            default: 10240
        },
    },
    data() {
        return {
            valid:null,
            filename:null,
            hasUploaded:true,
            loading:false
        }
    },
    computed: {
        isMobile(){
            return this.isSmAndDownDevice;
        },
        sheetHeight(){
            return this.isXsDevice?(200):this.isSmDevice?300:400;
        },
        avatarUrl () {
            let folder=`fotos/event_${this.eventId}_teamId_${this.teamId}/`;
            if(this.hasUserInput){
                if (this.filename && this.filename.indexOf(folder)>-1){
                    return `${this.imageBaseUrl}/${this.filename}`;
                }else{
                    return `${this.imageBaseUrl}/${folder}${this.filename}`;
                }
            }else if(!this._.isEmpty(this.filename)){
                return `${this.imageBaseUrl}/${folder}${this.filename}`;
            }
            return this.filename;
        },
        cameraChoice() {
            return this.parseBoolean(CONFIG.ENABLE_TASK_CAMERA_CHOICE, false)
        }
    },
    watch:{
        /* Init data on creation and on update */
        spot: {
            handler() {
                if(this.hasUserInput){
                    this.filename=this._.first(this.userInput);
                }
            },
            immediate: true,
            deep:true
        },
        /*
        selected(){
            this.$emit('input',this.selected,this.getServerData(this.selected));
        }
        */
    },

    methods: {
        // Responsible for performing the upload request to your API
        request (form, config) {
            let timestamp=this.formatDateTime();
            let date=this.formatDateTime();

            if(this.isImage(this.filename)){
                return Media.uploadPhoto(form,config,this.filename,this.eventId,this.spot.id,timestamp,date);
            }else if(this.isVideo(this.filename)){
                return Media.uploadVideo(form,config,this.filename,this.eventId,this.spot.id,timestamp,date);
            }
            return null;
        },
        rename (file) {
            if(file && file.name){
                const fileSplitted=file.name.split('.');
                const ext = fileSplitted[fileSplitted.length-1];
                const currentTimestamp=new Date().getTime();
                this.filename=`event_${this.eventId}_wp_${this.spot.id}_player_${this.userId}_${currentTimestamp}.${ext}`
            }else{
                console.warn('Uploaded image has no name');
                this.filename='unnamed.jpg';
            }
            return this.filename;
        },

        resetUpload(){
            this.filename=null;
            this.hasUploaded=false;
        },

        success () {//{ data }
            this.$emit('input',this.filename,this.getServerData(this.filename,true));
        },
        failed () {//error
            EventBusNotification.$emit('notify',this.$t('msgTechnicalError'));
            this.resetUpload();
        },
        onErrorSize(){
            const fileSizeInMb=(this.maxSize/1024);
            EventBusNotification.$emit('notify',this.$t('error_file_to_big',{fileSize:fileSizeInMb}));
            this.resetUpload();
        },
        onErrorType(){
            EventBusNotification.$emit('notify',this.$t('error_file_wrong_type'));
            this.resetUpload();
        },
        onLoading(loading){
            this.loading=loading;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>